module.exports = __webpack_public_path__ + "static/media/alex-nature.96add150.jpg";